import Vue from 'vue';
import Router from 'vue-router';
import MainView from '../views/MainView';
import AboutView from '../views/AboutView';
import TosView from '../views/TosView';
import PrivacyView from '../views/PrivacyView';
import NotFoundView from '../views/NotFoundView';

Vue.use(Router);

const router = new Router({
  history: true
});

router.map({
  '/': {
    name: 'main',
    component: MainView
  },
  '/about': {
    name: 'about',
    component: AboutView
  },
  '/tos': {
    name: 'tos',
    component: TosView
  },
  '/privacy': {
    name: 'privacy',
    component: PrivacyView
  },
  '/404': {
    name: 'not-found',
    component: NotFoundView
  }
});

router.beforeEach(function () {
  window.scrollTo(0, 0);
});

router.redirect({
  '*': '/'
});

export default router;



/** WEBPACK FOOTER **
 ** ./src/router/index.js
 **/